import { render, staticRenderFns } from "./ShenPiJiGouEdit.vue?vue&type=template&id=664e7140&scoped=true&"
import script from "./ShenPiJiGouEdit.vue?vue&type=script&lang=js&"
export * from "./ShenPiJiGouEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiJiGouEdit.vue?vue&type=style&index=0&id=664e7140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e7140",
  null
  
)

export default component.exports